import React from 'react';

import { useIntl } from '@utils/intl';
import { BookingIcon } from '@views/shared/BookingIcon';
import { BOOK_CATEGORY_VACATION, getBookingIcon } from '@views/shared/consts';
import { Panel } from '@views/Book/Bookings/Panel';
import { useGoTo } from '@views/shared/utils/useGoTo';

export default function Vacation() {
  const { t } = useIntl();

  const { goToBookingPage } = useGoTo();

  return (
    <Panel
      icon={<BookingIcon name={getBookingIcon(BOOK_CATEGORY_VACATION)} />}
      name={t('Home.ActiveBookings.Booking.title.vacation')}
      onAction={() => goToBookingPage({ type: BOOK_CATEGORY_VACATION })}
    />
  );
}
